import { authenticatedPaths, NOAUTH_ROUTES } from "../routes";
import type { RouterAdapter } from "../adapter";

export const browserRouterAdapter = () => {
  if (typeof window === "undefined") {
    if (typeof process !== "undefined" && !process.env.NEXT_RUNTIME) {
      throw new Error(
        "browserRouterAdapter can only be used in a browser environment",
      );
    }
  }

  return {
    async push(path: string) {
      window.history.pushState({}, "", path);
    },
    async replace(path: string) {
      window.history.replaceState({}, "", path);
    },
    async go(delta: number) {
      window.history.go(delta);
    },
    async back() {
      window.history.back();
    },
    async forward() {
      window.history.forward();
    },
    getPath() {
      return window.location.pathname;
    },
    isAuthenticatedPath(path?: string) {
      // Implement your logic to determine if the path requires authentication
      return authenticatedPaths.includes(
        (path || this.getPath()) as (typeof authenticatedPaths)[number],
      );
    },
    async redirectToAuth(redirectTo?: string) {
      const authPath = NOAUTH_ROUTES.signIn.path;
      const redirectUrl = redirectTo
        ? `${authPath}?redirectTo=${encodeURIComponent(redirectTo)}`
        : authPath;
      window.location.href = redirectUrl;
    },
    type: "browser" as const,
  } satisfies RouterAdapter;
};
